import { Box, IconButton } from '@mui/material';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import { useFieldHelper } from 'framework/ui/field';
import { ACCESS_INFO_ACTIONS, ACCESS_INFO_SECTIONS, useProjectSecurityContext } from 'domain/shared/newProject';
import { ASSUMPTION_STATUS, AssumptionType } from '../../types';
import { useAssumptionActions } from '../../CreateAndUpdateAssumption/AssumptionActionsProvider';

const EditActionField = () => {
  const { getData } = useFieldHelper<unknown>({ source: 'id' });
  const { isAccessGranted } = useProjectSecurityContext();
  const { openUpdate } = useAssumptionActions();
  const row = getData() as AssumptionType | undefined;

  const canEdit =
    isAccessGranted(ACCESS_INFO_SECTIONS.ASSUMPTION, ACCESS_INFO_ACTIONS.MANAGE) ||
    isAccessGranted(ACCESS_INFO_SECTIONS.ASSUMPTION, ACCESS_INFO_ACTIONS.REVIEW) ||
    isAccessGranted(ACCESS_INFO_SECTIONS.ASSUMPTION, ACCESS_INFO_ACTIONS.PARTIAL_MANAGE);

  if (!row || row.status === ASSUMPTION_STATUS.INACTIVE || !canEdit) {
    return <Box sx={{ width: '100%' }} />;
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
      <IconButton onClick={() => openUpdate(row)} size="small">
        <AppRegistrationIcon color="primary" />
      </IconButton>
    </Box>
  );
};

export default EditActionField;
